var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/core-js/modules/_core.js
// module id = ../../../../core-js/modules/_core.js
// module chunks = 1